import request from "../../Utils/curl"
import Utility from "../../Utils/utility"

let SpcmCalendarCategorys = {
  /**
   * SpcmCalendarCategory List
   */
  async SpcmCalendarCategoryList (context, whereFilter = null) {
    try {
      let postData = new FormData()
      if (whereFilter) {
        postData.append("filter", JSON.stringify(whereFilter))
      }

      return await request.curl(context, "spcm_calendar_category_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at SpcmCalendarCategoryList() and Exception:", err.message)
    }
  },

  /**
   * SpcmCalendarCategory View
   */
  async SpcmCalendarCategoryView (context, SpcmCalendarCategoryId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("spcm_calendar_category_id", SpcmCalendarCategoryId)

      return await request.curl(context, "spcm_calendar_category_view", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at SpcmCalendarCategoryView() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * SpcmCalendarCategory Add
   */
  async SpcmCalendarCategoryAdd (context, SpcmCalendarCategoryObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in SpcmCalendarCategoryObj) {
        postData.append(key, SpcmCalendarCategoryObj[key])
      }

      return await request.curl(context, "spcm_calendar_category_add", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at SpcmCalendarCategoryAdd() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * SpcmCalendarCategory Edit
   */
  async SpcmCalendarCategoryEdit (context, SpcmCalendarCategoryObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in SpcmCalendarCategoryObj) {
        postData.append(key, SpcmCalendarCategoryObj[key])
      }

      return await request.curl(context, "spcm_calendar_category_edit", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at SpcmCalendarCategoryEdit() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * SpcmCalendarCategory Delete
   */
  async SpcmCalendarCategoryDelete (context, SpcmCalendarCategoryId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("spcm_calendar_category_id", SpcmCalendarCategoryId)

      return await request.curl(context, "spcm_calendar_category_delete", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at SpcmCalendarCategoryDelete() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * SpcmCalendarCategory FilterList
   */
  async SpcmCalendarCategoryFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "spcm_calendar_category_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at spcm_calendar_category_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  SpcmCalendarCategorys
}
